export var Urls = {
    GetValidationRules: "validations/getvalidationrules",
    GetValidationRulesForLevel: "validations/GetValidationRules",
    SaveValidationRulesForLevel: "validations/SaveValidationRulesForLevel",
    GetValidationRootEntities: "validations/GetValidationRootEntities",
    ValidateChildEntity: "validations/validateChildEntity",
    Validate: "validations/validate"
};
